module.exports.merlin = {
  vi: {
    title: 'Merlin trong Avalon: năng lực, ngoại lệ Mordred và chiến thuật',
    description:
      'Tìm hiểu Merlin thấy ai trong Avalon, vì sao Mordred vẫn ẩn mình, mối liên hệ của Percival với Morgana và cách dẫn dắt phe Thiện mà không lộ mình cho Sát thủ.',
    keywords: ['Merlin', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Merlin em Avalon: habilidades, Mordred e estratégia',
    description:
      'Saiba quem Merlin vê em Avalon, por que Mordred fica oculto, como Percival e Morgana interagem e como ajudar o bem sem revelar sua identidade.',
    keywords: ['Merlin', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Merlin in Avalon: Abilities, Mordred Exception & Strategy',
    description:
      'Learn who Merlin sees in Avalon, why Mordred stays hidden, how Percival and Morgana interact, and how to guide good without revealing yourself to the Assassin.',
    keywords: ['Merlin', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Мерлин в Авалоне: способности, Мордред и стратегия',
    description:
      'Кого видит Мерлин в Авалоне, почему скрыт Мордред, как связаны Персиваль и Моргана и как помочь добру, не выдав себя Убийце.',
    keywords: ['Мерлин', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆梅林：角色能力、莫德雷德與玩法策略',
    description:
      '梅林能看到誰？了解阿瓦隆梅林的能力、莫德雷德隱藏規則、派西維爾與莫甘娜的關係，以及如何幫助好人完成任務並躲過刺殺。',
    keywords: ['梅林', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆梅林：角色能力、莫德雷德与玩法策略',
    description:
      '梅林能看到谁？了解阿瓦隆梅林的能力、莫德雷德隐藏规则、派西维尔与莫甘娜的关系，以及如何帮助好人完成任务并躲过刺杀。',
    keywords: ['梅林', '角色', '规则', '建议'],
  },
  es: {
    title: 'Merlín en Avalon: habilidades, Mordred y estrategia',
    description:
      'Descubre a quién ve Merlín en Avalon, por qué Mordred permanece oculto, cómo interactúan Percival y Morgana y cómo ayudar al bien sin revelar tu identidad.',
    keywords: ['Merlín', 'Rol', 'Reglas', 'Consejos'],
  },
};
